/**
 * Helper function to apply scaling to nodes
 * @param {Array} nodes - The nodes to scale
 * @param {Number} horizontalScale - Horizontal scale factor
 * @param {Number} verticalScale - Vertical scale factor
 * @returns {Array} Scaled nodes
 */
const applyScalingToNodes = (nodes, horizontalScale, verticalScale) => {
  if (!nodes || nodes.length === 0) return nodes;

  // Calculate the center point
  let sumX = 0,
    sumY = 0;
  let nodeCount = 0;

  // Only use positions from nodes without a parent (to avoid scaling children independently)
  const topLevelNodes = nodes.filter((node) => !node.parentNode);

  topLevelNodes.forEach((node) => {
    sumX += node.position.x;
    sumY += node.position.y;
    nodeCount++;
  });

  if (nodeCount === 0) return nodes;

  const centerX = sumX / nodeCount;
  const centerY = sumY / nodeCount;

  // Apply scaling to all nodes
  return nodes.map((node) => {
    // Skip child nodes - they will move with their parents
    if (node.parentNode) return node;

    const vectorX = node.position.x - centerX;
    const vectorY = node.position.y - centerY;

    return {
      ...node,
      position: {
        x: centerX + vectorX * horizontalScale,
        y: centerY + vectorY * verticalScale,
      },
    };
  });
};

export default applyScalingToNodes;
